// extracted by mini-css-extract-plugin
export default {"container":"InfoLabelValue_container__0i0z7","theme-default":"InfoLabelValue_theme-default__gGmHt","theme-visa":"InfoLabelValue_theme-visa__d49io"};